import { useDialog } from 'shared/components/Dialog';

import { Provider } from './context';

import type { PropsWithChildren as DialogProviderProps, FC } from 'react';

export const DialogProvider: FC<DialogProviderProps> = ({ children }) => {
  const dialog = useDialog();

  return <Provider value={{ ...dialog }}>{children}</Provider>;
};
